import clsx from 'clsx';
import React from 'react';

import { Button } from '../BaseButton/Button';

type SecondaryButtonV2Props = Omit<
  JSX.IntrinsicElements['button'],
  'background' | 'fontDecoration' | 'extraClassNames' | 'color'
> & {
  secondaryIcon?: React.ReactNode;
  withBorder?: boolean;
};

export const SecondaryButtonV2 = ({
  onClick,
  disabled = false,
  children,
  className,
  type = 'button',
  secondaryIcon,
  withBorder = false,
  ...props
}: SecondaryButtonV2Props) => (
  <Button
    type={type}
    onClick={onClick}
    disabled={disabled}
    borderWidth={withBorder ? 'border-[0.5px]' : undefined}
    extraClassNames={clsx(
      'hover:enabled:cursor-pointer hover:disabled:cursor-not-allowed',
      withBorder && 'border-main-300 box-border',
      className
    )}
    background="disabled:bg-main-200 bg-main-200 hover:enabled:bg-negative"
    fontDecoration="no-underline"
    color="hover:disabled:text-main-500 disabled:text-main-500 enabled:text-main hover:enabled:text-main"
    {...props}
  >
    {children}
    {secondaryIcon && <span className="text-main-500">{secondaryIcon}</span>}
  </Button>
);
